import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-unauthorized',
    templateUrl: './unauthorized.component.html',
    styleUrls: ['./unauthorized.component.css'],
    standalone: false
})
export class UnauthorizedComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }

}
